/* One homepage-style search/cart implementation, used by both layouts.
   Native Shopify endpoints remain the only source of cart and search data. */
(() => {
  const host = document.getElementById('giesto-header-surfaces');
  if (!host || host.dataset.ready) return;
  host.dataset.ready = 'true';
  const tr = host.dataset.locale.startsWith('tr');
  const productTitle = value => window.GiestoProductTitle?.(value) ?? value;
  const text = (turkish, english) => tr ? turkish : english;
  const prefix = host.dataset.root.replace(/\/$/, '');
  const local = path => prefix + '/' + String(path).replace(/^(?:\/en)+(?=\/|$)/, '').replace(/^\//, '');
  const search = host.querySelector('.ghs-search'), cart = host.querySelector('.ghs-cart'), account = host.querySelector('.ghs-account');
  const input = search.querySelector('input[name=q]');
  const searchForm = search.querySelector('[data-ghs-search-form]');
  const searchClear = search.querySelector('[data-ghs-search-clear]');
  const results = search.querySelector('[data-ghs-results]');
  const resultsLabel = search.querySelector('[data-ghs-results-label]');
  const searchAll = search.querySelector('[data-ghs-search-all]');
  let initialResults = '', searchDefaults;
  const searchStatus = search.querySelector('[data-ghs-search-status]');
  // The controls in either header that open this overlay.
  const SEARCH_TRIGGER = 'header input[type="search"],header input[name="q"],[data-testid="header-search"]';
  // Shopify's own themes wait 200-300 ms; at 500 ms the results trailed the typing noticeably.
  const SEARCH_DELAY = 120;
  const SEARCH_LIMIT = 10;
  const DEFAULTS_LIMIT = 16;
  const DEFAULTS_TTL = 5 * 60 * 1000;
  const defaultsKey = `giesto:search-defaults:v5:${host.dataset.locale}:${host.dataset.currency}:${window.Shopify?.theme?.id || 'live'}:${search.dataset.ghsDefaultsUrl}`;
  let searchVersion = 0, composingSearch = false;
  // Answers already received on this page, by query, so retyping or deleting back is instant.
  const searchCache = new Map();
  /* Typed results are drawn exactly like the curated ones from
     giesto-search-suggestions.liquid: the same widths and sizes, so a tile
     never downloads the original upload (often 100-500 KB) for a ~200px slot. */
  const SEARCH_IMAGE_WIDTHS = [200, 400, 600];
  const SEARCH_IMAGE_SIZES = '(min-width: 1025px) 15vw, (min-width: 750px) 28vw, 43vw';
  const cartStatus = cart.querySelector('[data-ghs-cart-status]');
  const itemsPanel = cart.querySelector('.ghs-cart__items');
  const recent = cart.querySelector('[data-ghs-recent]');
  const recentRail = cart.querySelector('[data-ghs-recent-rail]');
  const checkout = cart.querySelector('[data-ghs-checkout]');
  checkout.href = local('/checkout');
  let trigger, searchOrigin, previousOverflow, restoring = false, searchTimer, searchRequest, cartData, activeTab = 'cart', cartRequest = 0, recentRequest = 0, lastSearchQuery = '';
  // The delivery promise. `giesto-free-shipping.liquid` is the only place these
  // amounts are read from, so the drawer cannot disagree with the product page
  // or the cart page about where the threshold sits or what delivery costs
  // below it. Both are in minor units.
  const freeShippingThreshold = Number(host.dataset.freeShippingThreshold) || 0;
  const shippingFee = Number(host.dataset.shippingFee) || 0;
  // What only this cart knows (discount answers, its own failures) goes to
  // giesto-funnel.js, which reports it with the rest of the purchase funnel.
  const funnel = (name, fields) => document.dispatchEvent(new CustomEvent('giesto:funnel', {detail: {name, fields}}));
  // "Şunları da beğenebilirsiniz" in a bag with items is an A/B test (YUN-89):
  // variant B of `sepet-oneri` shows the rail, A keeps it hidden as since YUN-78.
  const cartRecommendations = () => window.GiestoDeney?.variant('sepet-oneri') === 'B';
  // Discount box A/B test (YUN-89): group B of `indirim-kutusu` sees an offer
  // in a bag with items. The rule follows YUN-108: full-price products only,
  // from a 4.000 ₺ bag. `code` must be a Shopify discount with exactly that
  // rule; until it exists the box never shows and the test stays off in
  // giesto-experiments.liquid. threshold is in kuruş, like cart.js amounts.
  const OFFER = {code: '', percent: 10, threshold: 400000};
  // Sonbahar/Kış sepet indirimi (YUN-138): Shopify's three automatic discounts
  // take 300/400/500 ₺ off once basic™ and F/W27 items reach 3.000/4.000/5.000 ₺.
  // The line under the free-delivery bar is on while the theme setting is (the
  // host carries the discounts' title then). Amounts in kuruş, like cart.js.
  const CAMPAIGN = host.dataset.tierCampaign ? {title: host.dataset.tierCampaign, tiers: [[300000, 30000], [400000, 40000], [500000, 50000]]} : null;
  // GIESTO Fırsatları (YUN-188): giesto-firsat.js knows the campaigns and their dates;
  // the host carries the theme setting. Asked at render time, so the dates decide.
  const FIRSAT_ON = host.hasAttribute('data-firsat-campaign');
  const firsat = () => FIRSAT_ON && window.GiestoFirsat?.active() ? window.GiestoFirsat : null;
  // Estimated delivery: this many delivery days after the order day in
  // Istanbul. The carriers deliver Monday to Saturday, so only Sunday is
  // skipped (YUN-78). Ordered Thursday 15 October → 16 - 19 October.
  const DELIVERY_DAYS = [1, 3];
  // Shopify checkout's bag icon returns to /cart, which shows this same cart.
  const cartPage = host.hasAttribute('data-cart-page');
  const money = cents => new Intl.NumberFormat(tr ? 'tr-TR' : 'en-GB', {style:'currency', currency:cartData?.currency || host.dataset.currency || 'TRY'}).format(cents / 100);
  function element(tag, className, value) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined) node.textContent = value;
    return node;
  }
  // Icons are the archived ARKET sprite paths, not redrawn controls.
  function icon(name) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    const use = document.createElementNS('http://www.w3.org/2000/svg','use');
    use.setAttribute('href',host.dataset.icons + '#' + name);
    svg.setAttribute('aria-hidden','true');svg.append(use);return svg;
  }
  function productLink(path) {
    const url = new URL(path, window.location.origin);
    return local(url.pathname) + url.search;
  }
  function readRecent() {
    try {
      const value = JSON.parse(localStorage.getItem('viewedProductDetails') || '[]');
      return Array.isArray(value) ? value.filter(item => item?.handle).slice(0, 8) : [];
    } catch { return []; }
  }
  function rememberCurrentProduct() {
    const id = host.dataset.currentProductId, handle = host.dataset.currentProductHandle;
    if (!id || !handle) return;
    try {
      const details = readRecent().filter(item => String(item.id) !== String(id) && item.handle !== handle);
      details.unshift({id, handle});
      localStorage.setItem('viewedProductDetails', JSON.stringify(details.slice(0, 8)));
      const ids = details.map(item => String(item.id));
      localStorage.setItem('viewedProducts', JSON.stringify(ids));
    } catch { /* Recent products are optional when storage is unavailable. */ }
  }
  // Shared dialog lifecycle preserves focus and respects reduced motion.
  const DRAWER_TRANSITION = 150;
  const closing = new Set();
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function show(dialog, origin, modal = true) {
    if (dialog.open) {
      // Re-opening mid-close: catch the panel and send it back out.
      if (closing.delete(dialog)) dialog.setAttribute('data-ghs-open','');
      return;
    }
    trigger = origin;
    for (const other of [search, cart, account]) if (other?.open) other.close();
    document.querySelector('giesto-canonical-header')?.closeMobileMenu?.();
    document.querySelector('giesto-editorial-header')?.closeMenu?.({ immediate: true, restoreFocus: false });
    previousOverflow = document.documentElement.style.overflow;
    if (modal) document.documentElement.style.overflow = 'hidden';
    if (modal) dialog.showModal(); else dialog.show();
    if(dialog===cart){const heading=cart.querySelector('#ghs-cart-title');heading.tabIndex=-1;heading.focus({preventScroll:true});}
    if (dialog === cart || reducedMotion()) {dialog.setAttribute('data-ghs-open','');return;}
    requestAnimationFrame(() => requestAnimationFrame(() => {if (dialog.open) dialog.setAttribute('data-ghs-open','');}));
  }
  function close(dialog) {
    if (!dialog.open || closing.has(dialog)) return;
    dialog.removeAttribute('data-ghs-open');
    if (dialog === cart || reducedMotion()) {
      if(dialog!==account)document.documentElement.style.overflow=previousOverflow || '';
      restoring = true;dialog.close();return;
    }
    closing.add(dialog);
    setTimeout(() => {
      if (!closing.delete(dialog)) return; // show() caught it on the way out
      if (dialog.open) {restoring = true;dialog.close();}
    }, DRAWER_TRANSITION);
  }
  function syncSearchOrigin(value) {
    if (!searchOrigin?.isConnected) return;
    searchOrigin.value = value;
    searchOrigin.dispatchEvent(new Event('input', {bubbles:true, composed:true}));
  }
  window.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    if (document.querySelector('dialog[open]:not(.ghs-dialog)')) return;
    const dialog = [search, cart, account].find(item => item?.open);
    if (!dialog) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (dialog === search && input.value) {
      input.value = '';
      lastSearchQuery = '';
      syncSearchOrigin('');
      // Focus may be on a result that is about to be replaced.
      input.focus();
      updateSearch();
      return;
    }
    close(dialog);
  }, true);
  for (const dialog of [search, cart, account]) {
    if (!dialog) continue;
    dialog.querySelector('[data-ghs-close]')?.addEventListener('click', () => close(dialog));
    dialog.addEventListener('cancel', event => {event.preventDefault();close(dialog);});
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close(dialog);
    });
    dialog.addEventListener('close', () => {
      if (dialog === search) {
        clearTimeout(searchTimer); searchRequest?.abort(); searchVersion++;
        results.setAttribute('aria-busy', 'false');
      }
      closing.delete(dialog);
      dialog.removeAttribute('data-ghs-open');
      if (dialog !== account) document.documentElement.style.overflow = previousOverflow || '';
      restoring = true;
      if (trigger?.isConnected) trigger.focus({preventScroll:true});
      queueMicrotask(() => { restoring = false; });
    });
  }
  function openSearch(origin) {
    show(search, origin);
    searchOrigin = origin instanceof HTMLInputElement ? origin : null;
    input.value = searchOrigin?.value || lastSearchQuery;
    input.focus();
    updateSearch();
  }
  // Capture before the archived React listeners and before shadow-root listeners.
  // composedPath gives the actual source control in either header.
  window.addEventListener('click', event => {
    if (event.composedPath().includes(host)) return;
    const nodes = event.composedPath().filter(node => node instanceof Element);
    const cartButton = nodes.find(node => node.matches('[data-testid="header-cart"]'));
    if (cartButton) {
      event.preventDefault(); event.stopImmediatePropagation();
      activeTab = 'cart'; show(cart, cartButton); loadCart(); return;
    }
    const accountButton = nodes.find(node => node.matches('[data-testid="header-account"]'));
    if (accountButton) {
      event.preventDefault();event.stopImmediatePropagation();
      // Both headers go straight to Shopify's existing customer account flow.
      const destination = host.dataset.customer === 'true'
        ? host.dataset.accountUrl || local('/account')
        : host.dataset.loginUrl || local('/account/login');
      window.location.assign(destination);return;
    }
    if (account?.open && !nodes.includes(account)) close(account);
    const searchButton = nodes.find(node => node.matches(SEARCH_TRIGGER));
    if (searchButton && !restoring) {event.preventDefault();event.stopImmediatePropagation();openSearch(searchButton);}
  }, true);
  const captureSearchFocus = event => {
    if (event.composedPath().includes(host)) return;
    const field = event.composedPath().find(node => node instanceof Element && node.matches('header input[type="search"],header input[name="q"]'));
    if (!field) return;
    // React listens to focusin, while the native shadow header uses focus.
    // Block both, including the focus restored when closing the dialog.
    event.stopImmediatePropagation();
    if (!restoring && !search.open) openSearch(field);
  };
  window.addEventListener('focus', captureSearchFocus, true);
  window.addEventListener('focusin', captureSearchFocus, true);
  /* Pointing at, touching or tabbing to the search control is intent enough
     to fetch the curated products, so the overlay opens already filled
     instead of on "Loading…". Their photos load with them. */
  const warmSearch = event => {
    if (searchDefaults) return;
    const path = event.composedPath();
    if (path.includes(host) || !path.some(node => node instanceof Element && node.matches(SEARCH_TRIGGER))) return;
    loadSearchDefaults().catch(() => {});
  };
  for (const type of ['pointerover', 'pointerdown', 'focusin']) window.addEventListener(type, warmSearch, {capture:true, passive:true});
  function loadSearchDefaults() {
    if (searchDefaults) return searchDefaults;
    searchDefaults = (async () => {
      let cached;
      try {
        cached = JSON.parse(sessionStorage.getItem(defaultsKey) || 'null');
        if (!cached || !Number.isFinite(cached.at) || Date.now() - cached.at < 0 || Date.now() - cached.at > DEFAULTS_TTL || typeof cached.products !== 'string' || typeof cached.categories !== 'string') cached = null;
      } catch { /* storage is optional */ }
      if (!cached) {
        const cards = [], ids = new Set(), pages = new Set();
        let next = new URL(search.dataset.ghsDefaultsUrl, location.origin), categoriesHTML;
        while (next && cards.length < DEFAULTS_LIMIT) {
          if (pages.has(next.href) || pages.size >= 40 || next.origin !== location.origin) throw new Error('Invalid search suggestion pagination');
          pages.add(next.href);
          const response = await fetch(next, {signal: AbortSignal.timeout(10000)});
          if (!response.ok) throw new Error('Search suggestions unavailable');
          const content = new DOMParser().parseFromString(await response.text(), 'text/html');
          const products = content.querySelector('[data-ghs-default-products]');
          const categories = content.querySelector('[data-ghs-default-categories]');
          if (!products || !categories) throw new Error('Search suggestions unavailable');
          categoriesHTML ??= categories.innerHTML;
          for (const card of products.content.querySelectorAll('a[data-product-id]')) {
            if (ids.has(card.dataset.productId)) continue;
            ids.add(card.dataset.productId); cards.push(card.outerHTML);
            if (cards.length === DEFAULTS_LIMIT) break;
          }
          const following = products.content.querySelector('[data-ghs-default-next]')?.content.textContent.trim();
          next = following ? new URL(following, location.origin) : null;
          next?.searchParams.set('section_id', 'giesto-search-suggestions');
        }
        cached = {at: Date.now(), products: cards.join(''), categories: categoriesHTML};
        try { sessionStorage.setItem(defaultsKey, JSON.stringify(cached)); } catch { /* storage is optional */ }
      }
      initialResults = cached.products;
      search.querySelector('#ghs-categories-panel').innerHTML = cached.categories;
      if (!input.value.trim()) {
        renderCurated();
        searchStatus.textContent = initialResults ? '' : text('Şu an önerilecek ürün bulunmuyor. Arama yapabilirsiniz.', 'No recommendations right now. Try a search.');
      }
    })().catch(error => {
        searchDefaults = undefined;
        throw error;
      });
    return searchDefaults;
  }
  const curatedLabel = () => text('SİZİN İÇİN SEÇTİKLERİMİZ','CURATED FOR YOU');
  function sizedImage(url, width) {
    const sized = new URL(url, window.location.origin);
    sized.searchParams.set('width', width);
    return sized.href;
  }
  function resultLink(item, index) {
    const link = element('a'); link.href = productLink(item.url);
    link.dataset.productId = item.id;
    const image = item.featured_image, imageUrl = image?.url || item.image;
    if (imageUrl) {
      const img = element('img');
      // sizes and srcset go first so the browser never starts on the bare src.
      img.sizes = SEARCH_IMAGE_SIZES;
      img.srcset = SEARCH_IMAGE_WIDTHS.map(width => sizedImage(imageUrl, width) + ' ' + width + 'w').join(', ');
      img.src = sizedImage(imageUrl, 600);
      if (image?.width && image?.height) {img.width = 600; img.height = Math.round(600 * image.height / image.width);}
      img.decoding = 'async'; img.alt = '';
      img.loading = index < 4 ? 'eager' : 'lazy';
      link.append(img);
    }
    link.append(element('span', '', productTitle(item.title)));
    return link;
  }
  const railButtons = [...search.querySelectorAll('[data-ghs-rail-step]')];
  function updateSearchRail() {
    const end = results.scrollWidth - results.clientWidth;
    for (const button of railButtons) button.disabled = Number(button.dataset.ghsRailStep) < 0 ? results.scrollLeft < 2 : results.scrollLeft >= end - 2;
  }
  function resetSearchRail() {
    results.scrollTo({left: 0, behavior: 'instant'});
    requestAnimationFrame(() => {results.scrollTo({left: 0, behavior: 'instant'}); updateSearchRail();});
  }
  for (const button of railButtons) button.addEventListener('click', () => {
    results.scrollBy({left: Number(button.dataset.ghsRailStep) * results.clientWidth * .8, behavior: reducedMotion() ? 'instant' : 'smooth'});
  });
  results.addEventListener('scroll', updateSearchRail, {passive: true});
  if (typeof ResizeObserver !== 'undefined') new ResizeObserver(updateSearchRail).observe(results);
  function renderCurated() {
    results.innerHTML = initialResults;
    results.dataset.ghsSource = 'bestsellers';
    resetSearchRail();
  }
  const browseTabs = [...search.querySelectorAll('[data-ghs-browse]')];
  function selectBrowse(tab) {
    for (const button of browseTabs) {
      const active = button === tab;
      button.setAttribute('aria-selected', String(active)); button.tabIndex = active ? 0 : -1;
      document.getElementById(button.getAttribute('aria-controls')).hidden = !active;
    }
  }
  for (const tab of browseTabs) {
    tab.addEventListener('click', () => selectBrowse(tab));
    tab.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? browseTabs[0] : event.key === 'End' ? browseTabs.at(-1) : browseTabs[(browseTabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + browseTabs.length) % browseTabs.length];
      selectBrowse(next); next.focus();
    });
  }
  search.addEventListener('click', event => {
    const chip = event.target.closest('[data-ghs-popular-query]');
    if (!chip || event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); input.value = chip.dataset.ghsPopularQuery; input.focus(); updateSearch();
  });
  /* Nothing matched: say so, and keep the curated products underneath so the
     panel still offers somewhere to go. */
  function showNoMatches(query) {
    funnel('search_no_results', {term: query});
    searchStatus.textContent = text('Eşleşen ürün bulunamadı.','No matching products.');
    search.setAttribute('data-ghs-fallback', '');
    searchAll.hidden = true;
    resultsLabel.textContent = curatedLabel();
    const fill = () => {if (input.value.trim() === query && search.hasAttribute('data-ghs-fallback')) renderCurated();};
    fill();
    if (!initialResults) loadSearchDefaults().then(fill, () => {});
  }
  function renderSearchResults(query, products) {
    results.replaceChildren(...products.map(resultLink));
    results.dataset.ghsSource = 'search';
    resetSearchRail();
    if (!products.length) showNoMatches(query);
  }
  async function updateSearch() {
    clearTimeout(searchTimer); searchRequest?.abort();
    const version = ++searchVersion;
    if (composingSearch) return;
    const query = input.value.trim();
    lastSearchQuery = input.value;
    syncSearchOrigin(input.value);
    searchClear.hidden = !query;
    searchForm.toggleAttribute('data-has-query', Boolean(query));
    search.toggleAttribute('data-has-query', Boolean(query));
    search.removeAttribute('data-ghs-fallback');
    searchAll.hidden = !query;
    searchAll.href = local('/search') + '?q=' + encodeURIComponent(query) + '&type=product';
    searchStatus.textContent = '';
    results.setAttribute('aria-busy', 'false');
    resultsLabel.textContent = query ? text('ARAMA SONUÇLARI','SEARCH RESULTS') : curatedLabel();
    if (!query) {
      renderCurated();
      if (!initialResults) searchStatus.textContent = text('Yükleniyor…', 'Loading…');
      try { await loadSearchDefaults(); }
      catch {
        if (version === searchVersion && !input.value.trim()) searchStatus.textContent = text('Öneriler yüklenemedi. Aramak için yazmaya başlayın.', 'Suggestions could not load. Type to search.');
      }
      return;
    }
    const cacheKey = query.normalize('NFKC').replace(/\s+/g, ' ').toLocaleLowerCase(host.dataset.locale);
    const cached = searchCache.get(cacheKey);
    if (cached) {renderSearchResults(query, cached); return;}
    results.setAttribute('aria-busy', 'true');
    searchTimer = setTimeout(async () => {
      searchRequest = new AbortController();
      try {
        const response = await fetch(local('/search/suggest.json') + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=' + SEARCH_LIMIT, {signal:searchRequest.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        const products = data.resources?.results?.products || [];
        if (version !== searchVersion) return;
        if (searchCache.size >= 50) searchCache.delete(searchCache.keys().next().value);
        searchCache.set(cacheKey, products);
        renderSearchResults(query, products);
      } catch (error) {
        if (error.name === 'AbortError' || version !== searchVersion) return;
        searchStatus.textContent = text('Tüm sonuçları görmek için Enter tuşuna basın.','Press Enter to view all results.');
      } finally {
        if (version === searchVersion) results.setAttribute('aria-busy', 'false');
      }
    }, SEARCH_DELAY);
  }
  input.addEventListener('input', updateSearch);
  input.addEventListener('compositionstart', () => {composingSearch = true; clearTimeout(searchTimer); searchRequest?.abort(); searchVersion++;});
  input.addEventListener('compositionend', () => {composingSearch = false; updateSearch();});
  /* Arrow keys walk the field and the result tiles as one list: down or right
     goes forward, up or left goes back, and back from the first tile returns
     to the field. Enter on a tile is the link's own activation. */
  const resultLinks = () => [...results.querySelectorAll('a[href]')];
  input.addEventListener('keydown', event => {
    if (event.key !== 'ArrowDown' || event.isComposing) return;
    const first = resultLinks()[0];
    if (!first) return;
    event.preventDefault();
    first.focus();
  });
  results.addEventListener('keydown', event => {
    const step = {ArrowDown:1, ArrowRight:1, ArrowUp:-1, ArrowLeft:-1}[event.key];
    if (!step) return;
    const links = resultLinks();
    const index = links.indexOf(event.target.closest?.('a'));
    if (index < 0) return;
    event.preventDefault();
    const next = links[index + step];
    if (next) next.focus();
    else if (step < 0) input.focus();
  });
  searchClear.addEventListener('click', () => {
    input.value = '';
    lastSearchQuery = '';
    syncSearchOrigin('');
    input.focus();
    updateSearch();
  });
  const headerControl = selector => document.querySelector('giesto-canonical-header')?.shadowRoot?.querySelector(selector) || document.querySelector(selector);
  function syncCartCount(count, attempt = 0) {
    const editorial = document.querySelectorAll('[data-geh-count]');
    if (editorial.length) {
      editorial.forEach(badge => { badge.textContent = String(count); badge.hidden = !count; badge.parentElement.setAttribute('aria-label', text('Sepetim', 'My bag') + (count ? ` (${count})` : '')); });
      return;
    }
    const button = headerControl('[data-testid="header-cart"]');
    if (!button) {
      if (attempt < 30) requestAnimationFrame(() => syncCartCount(count, attempt + 1));
      return;
    }
    let holder = button.querySelector(':scope > span');
    if (!holder) {holder=element('span');button.append(holder);}
    holder.replaceChildren();
    if (count > 0) {
      const badge=element('span');badge.dataset.ghsCartBadge='';badge.setAttribute('aria-hidden','true');
      badge.style.cssText='position:absolute;top:-.4rem;right:1rem;transform:translateX(100%);display:inline-block;box-sizing:border-box;min-width:1.6rem;height:1.6rem;padding:0 .4rem;border-radius:999px;background:rgb(8,81,189);color:white;text-align:center;font:1.2rem/1.8rem var(--font-small-caps,ga-small-caps),Arial,sans-serif;letter-spacing:-.02em';
      const number=element('span','',count > 99 ? '99+' : String(count));number.style.cssText='display:inline-block;transform:translateY(-.25rem)';badge.append(number);holder.append(badge);
    }
    button.setAttribute('aria-label',text('Sepetim','My bag') + (count ? ` (${count})` : ''));
  }
  function syncAccountState(attempt = 0) {
    const button = headerControl('[data-testid="header-account"]');
    if (!button) {
      if (attempt < 30) requestAnimationFrame(() => syncAccountState(attempt + 1));
      return;
    }
    button.removeAttribute('aria-expanded');
    button.removeAttribute('aria-haspopup');
    button.querySelector('[data-ghs-customer-dot]')?.remove();
    if (host.dataset.customer !== 'true') return;
    button.style.position = 'relative';
    const dot = element('span');
    dot.dataset.ghsCustomerDot = '';
    dot.setAttribute('aria-hidden', 'true');
    dot.style.cssText = 'position:absolute;right:7px;bottom:5px;width:8px;height:8px;border:1px solid #000;border-radius:50%;background:#159447;box-sizing:border-box';
    button.append(dot);
  }
  search.querySelector('[data-ghs-menu]').addEventListener('click', () => {
    const editorial = document.querySelector('giesto-editorial-header');
    if (editorial) {
      search.addEventListener('close', () => editorial.openMenu('new'), { once: true });
      close(search);
      return;
    }
    close(search);
    headerControl('[data-testid="header-navigation-menu-button"]')?.click();
  });
  // The archived submit adapter need not handle this shared native form.
  search.querySelector('form').addEventListener('submit', event => {
    event.preventDefault();window.location.assign(local('/search') + '?q=' + encodeURIComponent(input.value.trim()) + '&type=product');
  });
  /* Spinner, per the archived Spinner component: a bordered circle, dark on the
     black checkout button and light on a quantity control. */
  function spinner(theme) {
    const node = element('div','ghs-spinner ghs-spinner--' + theme);
    node.setAttribute('aria-hidden','true');
    return node;
  }
  /* Keep one checkout control below the total and one source of cart state.
     Applying a code updates Shopify without sending quantities or items. */
  const mobileCart = matchMedia('(max-width: 1023px)');
  // Fit the first row into the available scroll area with a 40px glimpse of
  // row two. Measure the actual bar/note/footer so translations and short
  // desktop windows do not hide the continuation. Image frames stay 2:3.
  let cartPeekFrame;
  function fitCartRows() {
    cancelAnimationFrame(cartPeekFrame);
    cartPeekFrame = requestAnimationFrame(() => {
      const multiple = activeTab === 'cart' && (cartData?.items?.length || 0) > 3;
      cart.toggleAttribute('data-ghs-multiple-rows', multiple);
      if (mobileCart.matches || !cart.open || !multiple) {
        itemsPanel.style.removeProperty('--ghs-cart-card-width');
        return;
      }
      const first = itemsPanel.querySelector('.ghs-cart__item');
      if (!first) return;
      const scroll = cart.querySelector('.ghs-cart__scroll');
      const available = scroll.getBoundingClientRect().bottom - itemsPanel.getBoundingClientRect().top - scroll.scrollTop;
      const info = first.querySelector('.ghs-cart__info').getBoundingClientRect().height;
      const gap = parseFloat(getComputedStyle(itemsPanel).rowGap);
      const width = Math.min(164, Math.max(104, (available - info - 8 - gap - 40) / 1.5));
      itemsPanel.style.setProperty('--ghs-cart-card-width', Math.floor(width) + 'px');
    });
  }
  const cartSizeObserver = new ResizeObserver(fitCartRows);
  cartSizeObserver.observe(cart.querySelector('.ghs-cart__scroll'));
  const tabs = cart.querySelector('.ghs-cart__tabs');
  const masthead = element('nav', 'ghs-cart__masthead');
  masthead.setAttribute('aria-label', text('Mağaza', 'Store'));
  const back = element('button'); back.type = 'button';
  back.setAttribute('aria-label', text('Menü', 'Menu'));
  back.append(icon('header-menu')); back.addEventListener('click', () => {
    cart.addEventListener('close', () => {
      const editorial = document.querySelector('giesto-editorial-header');
      if (editorial) editorial.openMenu('new');
      else headerControl('[data-testid="header-navigation-menu-button"]')?.click();
    }, {once:true});
    close(cart);
  });
  const brand = element('a', 'ghs-cart__brand'); brand.href = local('/');
  brand.setAttribute('aria-label', 'GIESTO'); brand.append(icon('logo'));
  masthead.append(back, brand);cart.prepend(masthead);
  const cartLinks = element('nav', 'ghs-cart__links');
  const helpLink = element('a', '', text('Yardım', 'Help'));helpLink.href = local('/pages/iletisim');
  cartLinks.append(helpLink);
  cart.querySelector('.ghs-cart__header > div').insertBefore(cartLinks, cart.querySelector('[data-ghs-close]'));
  cart.querySelector('[data-ghs-close]').append(element('span', '', text('Kapat', 'Close')));

  const footer = element('footer', 'ghs-cart__checkout-footer');
  const footerTotal = element('div', 'ghs-cart__footer-total');
  footerTotal.setAttribute('aria-live', 'polite'); footerTotal.setAttribute('aria-atomic', 'true');
  // What the total is made of, as DeFacto lists it: "2 Ürün", "Kargo", a
  // rule, then "Toplam" (YUN-78), on desktop and phones alike.
  const footerLines = element('dl', 'ghs-cart__footer-lines');
  footer.append(footerLines, footerTotal); footer.hidden = true; cart.append(footer);
  // Reassurance beside the button that leaves for checkout.
  const secure = element('p', 'ghs-cart__secure');
  const lock = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  const shackle = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  lock.setAttribute('viewBox', '0 0 16 16'); lock.setAttribute('aria-hidden', 'true');
  shackle.setAttribute('d', 'M3.5 7h9v7h-9zM5.5 7V5a2.5 2.5 0 0 1 5 0v2M8 9.75v1.5');
  lock.append(shackle); secure.append(lock, element('span', '', text('Güvenli Alışveriş', 'Secure shopping')));
  /* Free delivery sits above the lines: what is still missing, or that it has
     been earned, over a bar filled by the same share of the threshold. */
  const shippingProgress = element('div', 'ghs-cart__shipping-progress');
  const shippingProgressText = element('p');
  shippingProgressText.setAttribute('aria-live', 'polite');
  const shippingProgressBar = element('span', 'ghs-cart__shipping-progress-bar');
  const shippingProgressFill = element('span');
  shippingProgressBar.setAttribute('aria-hidden', 'true'); shippingProgressBar.append(shippingProgressFill);
  shippingProgress.append(shippingProgressText, shippingProgressBar); shippingProgress.hidden = true;
  itemsPanel.before(shippingProgress);
  // The discount box (OFFER) sits under it: what is missing, then one button.
  const offer = element('div', 'ghs-cart__offer');
  const offerText = element('p');
  offerText.setAttribute('aria-live', 'polite');
  const offerApply = element('button', 'ghs-cart__offer-apply', text('İndirimi Uygula', 'Apply Discount'));
  offerApply.type = 'button';
  offer.append(offerText, offerApply); offer.hidden = true;
  shippingProgress.after(offer);
  // While the campaign runs, the same bar carries its tiers as stops after free
  // delivery (YUN-138): one line naming the next goal, one bar, four stops.
  const shippingStops = element('div', 'ghs-cart__stops');
  shippingStops.setAttribute('aria-hidden', 'true'); shippingStops.hidden = true;
  shippingProgress.append(shippingStops);
  // Sale items do not count toward the tiers, whatever their collection; a note
  // under the bar names them. It opens by height so the lines below glide down.
  const campaignNote = element('div', 'ghs-cart__campaign-note');
  const campaignNoteClip = element('div');
  const campaignNoteBody = element('div', 'ghs-cart__campaign-note-body');
  const campaignNoteText = element('p');
  const campaignNoteIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  const campaignNoteMark = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  campaignNoteIcon.setAttribute('viewBox', '0 0 16 16'); campaignNoteIcon.setAttribute('aria-hidden', 'true');
  campaignNoteMark.setAttribute('d', 'M8 1.75a6.25 6.25 0 1 1 0 12.5 6.25 6.25 0 0 1 0-12.5zM8 7.25v4M8 4.75v.5');
  campaignNoteIcon.append(campaignNoteMark);
  campaignNoteText.setAttribute('aria-live', 'polite');
  campaignNoteBody.append(campaignNoteIcon, campaignNoteText); campaignNoteClip.append(campaignNoteBody);
  campaignNote.append(campaignNoteClip); campaignNote.setAttribute('aria-hidden', 'true');
  shippingProgress.after(campaignNote);
  // The Fırsatlar rows sit under the note: one per campaign the bag takes part in.
  const firsatPanel = element('div', 'ghs-cart__firsat');
  firsatPanel.setAttribute('aria-live', 'polite'); firsatPanel.hidden = true;
  campaignNote.after(firsatPanel);
  for (const node of [shippingProgress, campaignNote, firsatPanel, offer]) cartSizeObserver.observe(node);
  // Shopify's answer when the code did not apply, shown in the box itself
  // (the discount form's own status sits in a closed panel), for this bag total.
  let offerNote = null;
  offerApply.addEventListener('click', async () => {
    if (cartBusy) return;
    await updateDiscount([...new Set([...appliedDiscountCodes(), OFFER.code])], OFFER.code);
    const applied = appliedDiscountCodes().some(code => code.toUpperCase() === OFFER.code.toUpperCase());
    offerNote = applied ? null : {text: discountStatus.textContent, total: cartData?.total_price};
    renderOffer();
  });
  // The estimate closes the list of lines; renderCart appends it after them.
  const deliveryEstimate = element('p', 'ghs-cart__delivery-estimate');
  const discount = element('details', 'ghs-cart__discount');
  const discountToggle = element('summary', 'ghs-cart__discount-toggle', text('İndirim kodu ekle', 'Add discount code'));
  discount.append(discountToggle);
  const discountForm = element('form', 'ghs-cart__discount-form');
  const discountLabel = element('label', '', text('İndirim kodu', 'Discount code'));
  const discountInput = element('input');
  discountInput.id = 'ghs-discount-code'; discountInput.name = 'discount';
  discountInput.placeholder = text('Kodu girin', 'Enter code');
  discountInput.type = 'text'; discountInput.autocomplete = 'off';
  discountInput.autocapitalize = 'characters'; discountInput.spellcheck = false;
  discountInput.maxLength = 255; discountInput.required = true;
  discountInput.setAttribute('aria-describedby', 'ghs-discount-status');
  discountLabel.htmlFor = discountInput.id;
  const discountFields = element('div', 'ghs-cart__discount-fields');
  const discountApply = element('button', '', text('Uygula', 'Apply'));
  discountApply.type = 'submit';
  discountFields.append(discountInput, discountApply);
  const discountCodes = element('div', 'ghs-cart__discount-codes');
  const discountStatus = element('p', 'ghs-cart__discount-status');
  discountStatus.id = 'ghs-discount-status'; discountStatus.setAttribute('role', 'status');
  discountForm.append(discountLabel, discountFields);
  discount.append(discountForm, discountCodes, discountStatus);
  discount.hidden = true;
  cart.querySelector('[data-ghs-totals]').before(discount);
  let cartBusy = false, cartMutation = false;
  // The button names the amount it will charge: "₺1.579,89 — Ödeme".
  function cartCheckoutLabel() {
    // "Hemen Al" rather than "Ödeme" (YUN-165): the button names the purchase, not the form after it.
    const label = text('Hemen Al', 'Buy Now');
    return cartData?.item_count ? money(deliveryQuote().total - cartDiscountBreakdown().extra) + ' — ' + label : label;
  }
  function alignCartLayout() {
    cart.querySelector('.ghs-cart__header > div').prepend(tabs);
    footer.append(checkout, secure);
    if (mobileCart.matches) recent.before(discount);
    else footer.prepend(discount);
    if (!cartBusy) checkout.textContent = cartCheckoutLabel();
    if (cartData) renderCart();
  }
  checkout.addEventListener('click', event => {if (checkout.getAttribute('aria-disabled') === 'true') event.preventDefault();});
  mobileCart.addEventListener('change', alignCartLayout);
  alignCartLayout();
  // Keep existing manual codes when adding or removing one. Automatic
  // discounts remain Shopify's responsibility and are never sent as codes.
  function appliedDiscountCodes() {
    const codes = (cartData?.discount_codes || []).filter(entry => entry.applicable).map(entry => entry.code);
    const applications = [
      ...(cartData?.cart_level_discount_applications || []),
      ...(cartData?.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(entry => entry.discount_application))
    ];
    for (const application of applications) if (application?.type === 'discount_code') codes.push(application.title);
    return [...new Map(codes.filter(Boolean).map(code => [code.toUpperCase(), code])).values()];
  }
  function renderDiscount() {
    discount.hidden = activeTab !== 'cart' || !cartData?.item_count;
    const codes = appliedDiscountCodes();
    discountToggle.textContent = codes.length
      ? text('İndirim kodları (', 'Discount codes (') + codes.length + ')'
      : text('İndirim kodu ekle', 'Add discount code');
    discountCodes.replaceChildren();
    for (const code of codes) {
      const chip = element('div', 'ghs-cart__discount-code');
      const remove = element('button', '', '×'); remove.type = 'button';
      remove.disabled = cartBusy;
      remove.setAttribute('aria-label', text('İndirim kodunu kaldır: ', 'Remove discount code: ') + code);
      remove.addEventListener('click', () => updateDiscount(appliedDiscountCodes().filter(value => value.toUpperCase() !== code.toUpperCase())));
      chip.append(element('span', '', code), remove); discountCodes.append(chip);
    }
  }
  discountForm.addEventListener('submit', event => {
    event.preventDefault();
    const code = discountInput.value.trim();
    if (!code || cartBusy) return;
    if (code.includes(',')) {
      discountInput.setAttribute('aria-invalid', 'true');
      discountStatus.textContent = text('Kodları tek tek girin.', 'Enter one code at a time.'); return;
    }
    updateDiscount([...new Set([...appliedDiscountCodes(), code])], code);
  });
  discountInput.addEventListener('input', () => {discountInput.removeAttribute('aria-invalid'); discountStatus.textContent = '';});
  async function updateDiscount(codes, submittedCode) {
    if (cartBusy || cartMutation) return;
    cartMutation = true; ++cartRequest; cartRead=null; setCartBusy(true);
    discountStatus.textContent = ''; discountInput.removeAttribute('aria-invalid');
    try {
      const response = await fetch(local('/cart/update.js'), {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({discount: [...new Map(codes.map(code => [code.toUpperCase(), code])).values()].join(',')})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message);
      cartData = data;
      const accepted = !submittedCode || appliedDiscountCodes().some(code => code.toUpperCase() === submittedCode.toUpperCase());
      if (submittedCode) funnel('discount_code', {result: accepted ? 'applied' : 'rejected', code: submittedCode});
      if (accepted) {
        discountInput.value = '';
        discountStatus.textContent = text(submittedCode ? 'İndirim kodu uygulandı.' : 'İndirim kodu kaldırıldı.', submittedCode ? 'Discount code applied.' : 'Discount code removed.');
      } else {
        discountInput.setAttribute('aria-invalid', 'true');
        discountStatus.textContent = text('Bu kod bu sepet için geçerli değil.', 'This code is not valid for this cart.');
      }
      document.dispatchEvent(new CustomEvent('giesto:cart:change', {detail: data}));
    } catch {
      if (submittedCode) funnel('discount_code', {result: 'error', code: submittedCode});
      discountStatus.textContent = text('İndirim kodu güncellenemedi. Tekrar deneyin.', 'Could not update your discount code. Please try again.');
    } finally {
      cartMutation = false; setCartBusy(false); renderCart();
      if (!discount.hidden) discountInput.focus({preventScroll: true});
    }
  }
  function setCartBusy(busy) {
    cartBusy = busy;
    checkout.setAttribute('aria-disabled', String(busy || !cartData?.item_count));
    checkout.tabIndex = busy || !cartData?.item_count ? -1 : 0;
    discountInput.disabled = busy; discountApply.disabled = busy;
    for (const control of cart.querySelectorAll('.ghs-cart__quantity button, .ghs-cart__remove, .ghs-cart__discount-code button')) control.disabled = busy;
    if (busy) {checkout.replaceChildren(spinner('dark'));checkout.setAttribute('aria-busy','true');}
    else {checkout.replaceChildren(document.createTextNode(cartCheckoutLabel()));checkout.removeAttribute('aria-busy');}
  }
  let cartRead;
  function readCart() {
    if (cartRead) return cartRead;
    const pending = fetch(local('/cart.js'), {cache:'no-store'}).then(response => {
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    }).finally(() => {if (cartRead === pending) cartRead = null;});
    cartRead = pending;return pending;
  }
  async function loadCart() {
    if (cartMutation) return;
    const version = ++cartRequest;
    setCartBusy(true);
    // Paint the last authoritative snapshot immediately; revalidate before checkout.
    if (cartData) {renderCart();setCartBusy(true);}
    else renderCartSkeleton();
    checkout.setAttribute('aria-disabled','true');
    try {
      const data = await readCart();
      if (version !== cartRequest) return;
      cartData = data; cartStatus.textContent = ''; setCartBusy(false); renderCart();
      document.dispatchEvent(new CustomEvent('giesto:cart:loaded', {detail: data}));
    } catch {
      if (version !== cartRequest) return;
      funnel('cart_error', {code: 'CART_LOAD_FAILED'});
      setCartBusy(false);
      itemsPanel.removeAttribute('aria-busy');
      if(!cartData){itemsPanel.replaceChildren();footer.hidden=true;}
      checkout.setAttribute('aria-disabled','true'); checkout.tabIndex = -1;
      cartStatus.replaceChildren(element('span','',text('Sepet yüklenemedi. ','Unable to load your cart. ')));
      const retry = element('button','',text('Tekrar dene','Retry'));retry.addEventListener('click',loadCart);cartStatus.append(retry);
    }
  }
  function renderCartSkeleton() {
    itemsPanel.replaceChildren();renderedCartSignature=null;
    itemsPanel.dataset.ghsPanel='cart';itemsPanel.setAttribute('aria-busy','true');
    recent.hidden=true;discount.hidden=true;footer.hidden=false;
    footerLines.replaceChildren();footerTotal.replaceChildren();
    for(let i=0;i<2;i++){
      const row=element('div','ghs-cart__item ghs-cart__skeleton');row.setAttribute('aria-hidden','true');
      const media=element('div','ghs-cart__media');
      const info=element('div','ghs-cart__info');
      for(let j=0;j<3;j++)info.append(element('span','ghs-cart__skeleton-line'));
      row.append(media,info);itemsPanel.append(row);
    }
  }
  function prepareCartImage(img, frame) {
    if(img.complete && img.naturalWidth)return;
    frame.dataset.imageLoading='';
    const ready=()=>{delete frame.dataset.imageLoading;img.removeEventListener('load',ready);img.removeEventListener('error',ready);};
    img.addEventListener('load',ready,{once:true});img.addEventListener('error',ready,{once:true});
  }
  let renderedCartSignature = null;
  function renderCart(force = false) {
    itemsPanel.removeAttribute('aria-busy');
    const saved = window.GiestoWishlist?.items || [];
    syncCartCount(cartData?.item_count || 0);
    if (!cartBusy) checkout.textContent = cartCheckoutLabel();
    cart.querySelector('#ghs-cart-title').textContent = text('Sepet','Cart');
    checkout.setAttribute('aria-disabled',String(cartBusy || !cartData?.item_count));
    checkout.tabIndex = !cartBusy && cartData?.item_count ? 0 : -1;
    cart.querySelector('[data-ghs-tab=cart] [data-ghs-tab-label]').textContent = text('Sepet','Cart') + ' | ' + (cartData?.item_count || 0) + ' |';
    cart.querySelector('[data-ghs-tab=saved] [data-ghs-tab-label]').textContent = text('Favoriler','Wishlist');
    for (const tab of cart.querySelectorAll('[data-ghs-tab]')) {const selected = tab.dataset.ghsTab === activeTab;tab.setAttribute('aria-selected',String(selected));tab.tabIndex = selected ? 0 : -1;}
    itemsPanel.setAttribute('aria-labelledby',activeTab === 'cart' ? 'ghs-cart-tab' : 'ghs-saved-tab');
    itemsPanel.dataset.ghsPanel = activeTab;
    fitCartRows();
    renderRecent();
    if (activeTab === 'saved') {renderedCartSignature=null;renderTotals();renderWishlist(saved);return;}
    const items = cartData?.items || [];
    const signature = JSON.stringify(items);
    if (!force && signature === renderedCartSignature) {renderTotals();return;}
    renderedCartSignature = signature;
    const previousMedia = new Map([...itemsPanel.querySelectorAll('.ghs-cart__item')].map(row=>[row.dataset.lineKey,row.querySelector('.ghs-cart__media')]));
    itemsPanel.replaceChildren();
    if (!items.length) {
      renderTotals();
      const empty = element('div','ghs-cart__empty');
      const media = element('div','ghs-cart__empty-media');
      media.setAttribute('aria-hidden','true');
      empty.append(media);
      empty.append(element('h3','',text('Sepetiniz boş','Your cart is empty')));
      const button = element('button','',text('Alışverişe devam et','Continue shopping'));button.addEventListener('click',()=>close(cart));empty.append(button);itemsPanel.append(empty);return;
    }
    for (const item of items) {
      // One item node per Shopify cart line; no catalogue request needed.
      const row=element('article','ghs-cart__item');row.dataset.lineKey=item.key;
      const imageUrl=item.featured_image?.url || item.image;
      const previous=previousMedia.get(item.key);
      const media=previous?.dataset.imageUrl===imageUrl?previous:element('a','ghs-cart__media');
      media.href=productLink(item.url || '/products/'+item.handle);media.dataset.imageUrl=imageUrl || '';
      if(imageUrl && !media.firstElementChild){const img=element('img');img.src=cartImage(imageUrl);img.srcset=[192,384,576].map(width=>cartImage(imageUrl,width)+' '+width+'w').join(', ');img.sizes='(max-width: 359px) 104px, (max-width: 1023px) 128px, 164px';img.width=192;img.height=288;img.loading=items.indexOf(item)<2?'eager':'lazy';img.decoding='async';img.alt=productTitle(item.product_title || item.title);media.append(img);prepareCartImage(img,media);}
      const info=element('div','ghs-cart__info'), top=element('div','ghs-cart__item-top'), link=element('a','ghs-cart__product-link');link.href=media.href;
      link.append(element('h3','',productTitle(item.product_title || item.title)));
      // These line totals add up to the summary's subtotal. Shopify's
      // distributed cart discounts are named once below, not hidden here.
      const original=item.original_line_price ?? item.original_price*item.quantity;
      // The free Basic Ayrıcalığı t-shirt alone shows its own deduction: crossed out, then 0.
      const gift=(item.line_level_discount_allocations || []).filter(entry => entry.discount_application?.title?.startsWith('Basic Ayrıcalığı')).reduce((sum, entry) => sum + entry.amount, 0);
      const price=element('p','ghs-cart__price',gift?'':money(original));
      if(gift)price.append(element('s','',money(original)),element('span','ghs-cart__price-now',money(Math.max(0,original-gift))));
      link.append(price);
      // No wishlist heart on cart lines (YUN-78); the Favoriler tab keeps its own.
      top.append(link);info.append(top);
      const bottom=element('div','ghs-cart__item-bottom');
      if(activeTab==='cart'){
        bottom.append(element('p','ghs-cart__variant',cartVariant(item)));
        const quantity=element('div','ghs-cart__quantity');
        for(const delta of [-1,1]){
          const button=element('button');button.type='button';
          button.setAttribute('aria-label',text(delta===1?'Adedi artır':item.quantity===1?'Kaldır':'Adedi azalt',delta===1?'Increase quantity':item.quantity===1?'Remove':'Decrease quantity')+': '+item.product_title);
          button.append(icon(delta===1?'navigate-more':item.quantity===1?'navigate-remove':'navigate-less'));
          button.addEventListener('click',()=>{
            // As in the archived CartItem: the line marks itself pending, both of
            // its controls go disabled and the pressed one becomes a spinner.
            // Nothing outside this row changes, so the panel never reflows.
            if (cartBusy || quantity.dataset.ghsPending) return;
            quantity.dataset.ghsPending = '';
            for (const control of quantity.querySelectorAll('button')) control.disabled = true;
            button.replaceChildren(spinner('light'));
            changeItem(item.key,item.quantity+delta);
          });quantity.append(button);
          if(delta===-1)quantity.append(element('span','',item.quantity));
        }
        const remove = element('button', 'ghs-cart__remove', text('Sil', 'Remove')); remove.type = 'button';
        remove.setAttribute('aria-label', text('Kaldır: ', 'Remove: ') + item.product_title);
        remove.addEventListener('click', () => changeItem(item.key, 0));
        bottom.append(quantity, remove);
      }
      info.append(bottom);row.append(media,info);itemsPanel.append(row);
    }
    itemsPanel.append(deliveryEstimate);
    renderTotals();
  }
  /* How far this cart is from free delivery, in minor units, or null when the
     promise does not apply: no threshold, nothing to ship, or a presentment
     currency the threshold was not set in. Measured against total_price, the
     after-discount amount Shopify's own price-based rates compare. */
  function freeShippingRemaining(){
    if(!freeShippingThreshold||!cartData?.requires_shipping)return null;
    const currency=cartData.currency||host.dataset.currency;
    if(host.dataset.shopCurrency&&currency&&currency!==host.dataset.shopCurrency)return null;
    return Math.max(0,freeShippingThreshold-cartData.total_price);
  }
  function cartVariant(item) {
    const options=item.options_with_values||[];
    const size=options.find(option=>/^(size|beden)$/i.test(option.name));
    if(size)return [size.value,...options.filter(option=>option!==size).map(option=>option.value)].join(' | ');
    return (item.variant_title||'').replace('Default Title','').split(' / ').reverse().join(' | ');
  }
  function cartImage(source, width = 192) {
    const url = new URL(source, location.origin);
    if (url.hostname === 'cdn.shopify.com' || (url.hostname === 'giesto.com' && url.pathname.startsWith('/cdn/'))) {url.protocol = 'https:'; url.searchParams.set('width', String(width));}
    return url.href;
  }
  /* What delivery costs this cart, in minor units: the flat fee until the
     threshold is reached, nothing after it. `null` is the promise not
     applying at all — a currency the amounts were not entered in — which is
     the one case still left to checkout, and which contributes nothing to the
     total because we do not know what it will be. This mirrors
     `applied_cents` in `giesto-free-shipping.liquid`. */
  function deliveryQuote(){
    const remaining=freeShippingRemaining();
    // Ajax cannot price a shipping discount until checkout has a delivery
    // address. Do not promise an undiscounted fee or a false inclusive total.
    const shippingDiscount = appliedDiscountCodes().length > 0 && !(cartData.total_discount > 0);
    const shipping=!cartData.requires_shipping?0:(shippingDiscount || remaining===null?null:(remaining>0?shippingFee:0));
    /* Delivery is part of the figure called a total; `total_price` is
       Shopify's merchandise total and never includes it. */
    return {remaining, shippingDiscount, shipping, total: cartData.total_price + (shipping || 0)};
  }
  // "16 Ekim - 19 Ekim": DELIVERY_DAYS counted from today in Istanbul, skipping Sundays.
  function deliveryWindow(){
    const today=Object.fromEntries(new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Istanbul',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date()).map(part=>[part.type,part.value]));
    const format=new Intl.DateTimeFormat(tr?'tr-TR':'en-GB',{day:'numeric',month:'long',timeZone:'UTC'});
    return DELIVERY_DAYS.map(days=>{
      const date=new Date(Date.UTC(Number(today.year),Number(today.month)-1,Number(today.day),12));
      while(days>0){date.setUTCDate(date.getUTCDate()+1);if(date.getUTCDay()!==0)days--;}
      return format.format(date);
    }).join(' - ');
  }
  function renderShippingProgress(){
    const quote=activeTab==='cart'&&cartData?.item_count?deliveryQuote():null;
    // Unsaid where the threshold does not apply, or a code may already make delivery free.
    shippingProgress.hidden=!quote||quote.remaining===null||(quote.remaining>0&&quote.shippingDiscount);
    lookupCampaign();
    const campaignNow=quote&&!shippingProgress.hidden?campaignQuote():null;
    // Until the bag's products are known the stops still show, unreached, and the
    // line pulses, so the answer fills the bar in place instead of growing it.
    const campaignPending=Boolean(CAMPAIGN&&quote&&!shippingProgress.hidden&&!campaignNow);
    shippingStops.hidden=!campaignNow&&!campaignPending;
    shippingProgress.classList.toggle('is-pending',campaignPending);
    if(campaignPending)shippingProgress.setAttribute('aria-busy','true');else shippingProgress.removeAttribute('aria-busy');
    if(shippingProgress.hidden)return;
    if(campaignPending){
      renderStops(null,quote);
      if(!shippingProgressText.querySelector('.ghs-cart__skeleton-line'))shippingProgressText.replaceChildren(element('span','ghs-cart__skeleton-line'));
      return;
    }
    // Written in title case, not capitals (YUN-78): "Ücretsiz Kargo Hakkı Kazandınız!"
    let parts=[quote.remaining>0
      ?text('Ücretsiz Kargo İçin '+money(quote.remaining)+' Kaldı','Add '+money(quote.remaining)+' More for Free Delivery')
      :text('Ücretsiz Kargo Hakkı Kazandınız!','You Have Earned Free Delivery!')];
    let filled=(freeShippingThreshold-quote.remaining)/freeShippingThreshold;
    if(campaignNow){
      // Free delivery first, then the next campaign tier, then what was earned.
      const {eligible, next}=campaignNow;
      // Campaigns do not combine: a tier Shopify passed over for a Fırsat is not "earned".
      const engine=firsat();
      const passedOver=Boolean(engine&&campaignNow.reached&&!campaignNow.applied&&(engine.applied(cartData,'Sepette Fırsat')||engine.applied(cartData,'Basic Ayrıcalığı')));
      const reached=passedOver?null:campaignNow.reached;
      const strong=value=>element('b','',value);
      if((quote.remaining<=0&&!passedOver)||reached)parts=!reached
        ?text([strong(money(next[0]-eligible)),' Daha Ekleyin, ',strong(whole(next[1])),' İndirim Kazanın'],['Add ',strong(money(next[0]-eligible)),' More for ',strong(whole(next[1])),' Off'])
        :!next
          ?text([strong(whole(reached[1])),' Sepet İndirimi Kazandınız!'],['You Have Earned ',strong(whole(reached[1])),' Off!'])
          :text([strong(whole(reached[1])),' İndirim Kazandınız · ',strong(money(next[0]-eligible)),' Daha Ekleyin, ',strong(whole(next[1])),' Olsun'],['You Have Earned ',strong(whole(reached[1])),' Off · Add ',strong(money(next[0]-eligible)),' More for ',strong(whole(next[1]))]);
      renderStops(eligible,quote);
      // The fill is what counts toward the tiers, so sale items do not move it.
      filled=Math.max(eligible,quote.remaining<=0?freeShippingThreshold:cartData.total_price+campaignNow.applied)/CAMPAIGN.tiers.at(-1)[0];
    }
    const message=parts.map(part=>typeof part==='string'?part:part.textContent).join('');
    if(shippingProgressText.textContent!==message||shippingProgressText.querySelector('.ghs-cart__skeleton-line'))shippingProgressText.replaceChildren(...parts);
    shippingProgressFill.style.width=(Math.min(1,filled)*100).toFixed(2)+'%';
  }
  // One scale up to the top tier; each stop darkens when its own rule is met.
  // `eligible` is null while the bag's products are being looked up.
  function renderStops(eligible,quote){
    const top=CAMPAIGN.tiers.at(-1)[0];
    // "₺300", never "TRY 300": four labels have to fit a 320px phone's bar.
    const narrow=cents=>new Intl.NumberFormat(tr?'tr-TR':'en-GB',{style:'currency',currency:cartData?.currency||host.dataset.currency||'TRY',currencyDisplay:'narrowSymbol',maximumFractionDigits:0}).format(cents/100);
    const stops=[[freeShippingThreshold,text('Ücretsiz kargo','Free shipping'),quote.remaining<=0],...CAMPAIGN.tiers.map(([minimum,amount])=>[minimum,narrow(amount),eligible!==null&&eligible>=minimum])];
    if(shippingStops.childElementCount!==stops.length)shippingStops.replaceChildren(...stops.map(()=>element('span')));
    stops.forEach(([at,label,done],index)=>{
      const stop=shippingStops.children[index];
      if(stop.textContent!==label)stop.textContent=label;
      stop.style.left=Math.min(100,at/top*100).toFixed(2)+'%';
      stop.classList.toggle('is-reached',done);
    });
  }
  /* Names the sale items in the bag, which the tiers never count, once per
     product, in bag order: "X ve Y indirimde olduğu için ...". */
  function renderCampaignNote(){
    const known = CAMPAIGN && activeTab === 'cart' && cartData?.item_count && !campaignLookup;
    const titles = known ? [...new Map(cartData.items
      .filter(item => campaignStatus.get(String(item.product_id)) === 'sale')
      .map(item => [item.product_id, item.product_title])).values()] : [];
    const open = titles.length > 0;
    campaignNote.classList.toggle('is-open', open);
    campaignNote.setAttribute('aria-hidden', String(!open));
    if (!open) return;
    // Beside the Fırsatlar rows, "the bag discount" has to say which one it means.
    const named = Boolean(firsat());
    const message = JSON.stringify([tr, titles, named]);
    if (campaignNoteText.dataset.message === message) return;
    campaignNoteText.dataset.message = message;
    const names = new Intl.ListFormat(tr ? 'tr' : 'en', {type: 'conjunction'}).formatToParts(titles)
      .map(part => part.type === 'element' ? element('b', '', part.value) : part.value);
    const discount = named ? text('Sonbahar/Kış sepet indirimine', 'the Autumn/Winter bag discount') : text('sepet indirimine', 'the bag discount');
    campaignNoteText.replaceChildren(...text(
      [...names, ' indirimde olduğu için ' + discount + ' dahil değildir.'],
      titles.length === 1
        ? [...names, ' is on sale, so it does not count toward ' + discount + '.']
        : [...names, ' are on sale, so they do not count toward ' + discount + '.']));
  }
  /* Which products count toward the campaign, by product id: "campaign",
     "sale" (on sale, so never counted, and named in the note) or "none". /cart.js
     does not carry collections, so a small section answers for the products in
     the bag; each product is asked about once. The answers are kept for the
     visit (a quarter of an hour), so later pages fill the bar without waiting. */
  const CAMPAIGN_CACHE = 'giesto:tier-campaign:3';
  const campaignStatus = new Map();
  // Fırsatlar flags per product id, from the same answer (see giesto-firsat.js).
  const firsatFlags = new Map();
  try {
    const saved = JSON.parse(sessionStorage.getItem(CAMPAIGN_CACHE) || 'null');
    if ((CAMPAIGN || FIRSAT_ON) && saved && Date.now() - saved.at < 15 * 60 * 1000) {
      for (const [id, status] of Object.entries(saved.statuses)) campaignStatus.set(id, status);
      for (const [id, flags] of Object.entries(saved.flags || {})) firsatFlags.set(id, flags);
    }
  } catch {}
  let campaignLookup = null;
  function lookupCampaignEligibility(){
    if (campaignLookup) return;
    const asked = cartData.items.map(item => String(item.product_id));
    const url = new URL(local('/cart'), location.origin);
    url.searchParams.set('section_id', 'giesto-tier-campaign');
    const theme = globalThis.Shopify?.theme;
    if (theme?.id && theme.role !== 'main' && theme.role !== 'live') url.searchParams.set('preview_theme_id', theme.id);
    const answered = {}, flagged = {};
    campaignLookup = fetch(url, {cache:'no-store'})
      .then(response => response.ok ? response.text() : '')
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const json = doc.querySelector('[data-tier-campaign-eligibility]')?.textContent;
        for (const [id, status] of Object.entries(json ? JSON.parse(json) : {})) if (['campaign', 'sale', 'none'].includes(status)) answered[id] = status;
        const flags = doc.querySelector('[data-firsat-eligibility]')?.textContent;
        for (const [id, value] of Object.entries(flags ? JSON.parse(flags) : {})) if (/^[ibg]*$/.test(value)) flagged[id] = value;
        try {
          const saved = Object.fromEntries([...campaignStatus].filter(([id]) => !(id in answered)));
          const savedFlags = Object.fromEntries([...firsatFlags].filter(([id]) => !(id in flagged)));
          sessionStorage.setItem(CAMPAIGN_CACHE, JSON.stringify({at: Date.now(), statuses: {...saved, ...answered}, flags: {...savedFlags, ...flagged}}));
        } catch {}
      })
      .catch(() => {})
      // A product the answer did not cover counts as not eligible, so a failed
      // lookup leaves the line unsaid instead of asking again on every render.
      .finally(() => {
        for (const id of asked) {
          campaignStatus.set(id, answered[id] || campaignStatus.get(id) || 'none');
          firsatFlags.set(id, flagged[id] ?? firsatFlags.get(id) ?? '');
        }
        campaignLookup = null; renderTotals(); if (!cartBusy) checkout.replaceChildren(document.createTextNode(cartCheckoutLabel()));
      });
  }
  /* Where the bag stands in the campaign, in kuruş: the basic™ and F/W27 amount,
     the tier it has reached, the next one, and what the totals take off for it.
     When Shopify has already applied the discount, cart.js totals carry it and
     nothing more is taken off here. */
  function campaignQuote(){
    if (!CAMPAIGN || activeTab !== 'cart' || !cartData?.item_count) return null;
    if (campaignLookup || cartData.items.some(item => !campaignStatus.has(String(item.product_id)))) return null;
    const eligible = cartData.items
      .filter(item => campaignStatus.get(String(item.product_id)) === 'campaign')
      .reduce((sum, item) => sum + item.original_line_price, 0);
    const applied = cartData.items.reduce((sum, item) => sum + (item.line_level_discount_allocations || [])
      .filter(allocation => allocation.discount_application?.title?.startsWith(CAMPAIGN.title))
      .reduce((total, allocation) => total + allocation.amount, 0), 0)
      + (cartData.cart_level_discount_applications || []).filter(application => application.title?.startsWith(CAMPAIGN.title))
        .reduce((sum, application) => sum + application.total_allocated_amount, 0);
    const reached = CAMPAIGN.tiers.filter(([minimum]) => eligible >= minimum).at(-1);
    const next = CAMPAIGN.tiers.find(([minimum]) => eligible < minimum);
    const discount = applied || (reached ? reached[1] : 0);
    return {eligible, reached, next, applied, discount, extra: applied ? 0 : discount};
  }
  // The tiers are whole liras: "₺300", not "₺300,00".
  const whole = cents => money(cents).replace(/[,.]00(?=\D*$)/, '');
  function lookupCampaign(){
    if ((CAMPAIGN || firsat()) && activeTab === 'cart' && cartData?.items?.some(item => !campaignStatus.has(String(item.product_id)) || !firsatFlags.has(String(item.product_id)))) lookupCampaignEligibility();
  }
  /* The Fırsatlar rows: where the bag stands in each campaign it takes part in, and,
     when two campaigns are reached at once, which one Shopify applied. */
  function renderFirsat(){
    const engine = firsat();
    const state = engine && activeTab === 'cart' && cartData?.item_count && !campaignLookup ? engine.quote(cartData, firsatFlags) : null;
    const {rows, note} = state ? engine.rows(state, {tr, money, root: host.dataset.root, tierReached: Boolean(campaignQuote()?.reached), gift: host.hasAttribute('data-firsat-gift')}) : {rows: [], note: null};
    firsatPanel.hidden = !rows.length;
    if (firsatPanel.hidden) {delete firsatPanel.dataset.message; return;}
    const message = JSON.stringify([rows, note]);
    if (firsatPanel.dataset.message === message) return;
    firsatPanel.dataset.message = message;
    const nodes = parts => parts.map(part => typeof part === 'string' ? document.createTextNode(part)
      : part.href ? Object.assign(element('a', '', part.text), {href: part.href}) : element('b', '', part.strong));
    const lines = rows.map(row => {
      const line = element('p', 'ghs-cart__firsat-row');
      line.append(element('span', 'ghs-cart__firsat-label', row.label), ...nodes(row.parts));
      return line;
    });
    if (note) {const line = element('p', 'ghs-cart__firsat-note'); line.append(...nodes(note)); lines.push(line);}
    firsatPanel.replaceChildren(...lines);
  }
  function renderOffer(){
    const withItems = activeTab === 'cart' && cartData?.item_count > 0;
    // Both groups count as exposed: this is where the box would show.
    if (withItems && OFFER.code) window.GiestoDeney?.seen('indirim-kutusu');
    const applied = appliedDiscountCodes().some(code => code.toUpperCase() === OFFER.code.toUpperCase());
    offer.hidden = !withItems || !OFFER.code || applied || window.GiestoDeney?.variant('indirim-kutusu') !== 'B';
    if (offer.hidden) return;
    const remaining = Math.max(0, OFFER.threshold - cartData.total_price);
    if (offerNote && offerNote.total !== cartData.total_price) offerNote = null;
    const message = offerNote?.text || (remaining > 0
      ? text(money(remaining) + ' Daha Ekleyin, İndirimsiz Ürünlerde %' + OFFER.percent + ' İndirim Kazanın', 'Add ' + money(remaining) + ' More for ' + OFFER.percent + '% Off Full-Price Items')
      : text('İndirimsiz Ürünlerde %' + OFFER.percent + ' İndirim Kazandınız!', 'You Have Earned ' + OFFER.percent + '% Off Full-Price Items!'));
    if (offerText.textContent !== message) offerText.textContent = message;
    offerApply.hidden = remaining > 0 || Boolean(offerNote);
    offerApply.disabled = cartBusy;
  }
  function cartDiscountBreakdown() {
    const subtotal = cartData.original_total_price;
    // Reconcile to Shopify's authoritative total, including rounding. Never
    // count an order discount again through its per-product allocations.
    let remaining = Math.max(0, subtotal - cartData.total_price);
    const grouped = new Map();
    const allocations = [
      ...cartData.items.flatMap(item => (item.line_level_discount_allocations || []).map(allocation => ({title: allocation.discount_application?.title, amount: allocation.amount}))),
      ...(cartData.cart_level_discount_applications || []).map(application => ({title: application.title, amount: application.total_allocated_amount}))
    ];
    for (const allocation of allocations) {
      const amount = Math.min(remaining, Math.max(0, Number(allocation.amount) || 0));
      if (!amount) continue;
      const title = CAMPAIGN && allocation.title?.startsWith(CAMPAIGN.title)
        ? text('Sonbahar/Kış sepet indirimi', 'Autumn/Winter bag discount')
        : globalThis.GiestoFirsat?.label(allocation.title, text) || allocation.title || text('Diğer indirimler', 'Other discounts');
      grouped.set(title, (grouped.get(title) || 0) + amount);
      remaining -= amount;
    }
    if (remaining) grouped.set(text('Diğer indirimler', 'Other discounts'), (grouped.get(text('Diğer indirimler', 'Other discounts')) || 0) + remaining);
    const campaign = campaignQuote();
    // An eligible tier not yet present in Ajax is an estimate for checkout,
    // not an applied discount. Do not combine it with another discount/code.
    const extra = subtotal === cartData.total_price && !appliedDiscountCodes().length ? campaign?.extra || 0 : 0;
    if (extra) grouped.set(text('Sepet indirimi (ödemede)', 'Bag discount (at checkout)'), extra);
    return {subtotal, extra, discounts: [...grouped].map(([title, amount]) => ({title, amount}))};
  }
  function renderTotals(){
    renderDiscount();
    renderShippingProgress();
    renderCampaignNote();
    renderFirsat();
    renderOffer();
    footer.hidden = activeTab !== 'cart' || !cartData?.item_count;
    const summary=cart.querySelector('[data-ghs-totals]');
    summary.hidden=true;summary.replaceChildren();
    if(activeTab!=='cart'||!cartData?.item_count)return;
    const {shipping, total: orderTotal}=deliveryQuote();
    deliveryEstimate.hidden=!cartData.requires_shipping;
    deliveryEstimate.textContent=text('Tahmini Teslimat: ','Estimated Delivery: ')+deliveryWindow();
    // The fee has its own line above the total; what is missing for free delivery is said above the items.
    const shippingLabel = shipping === null
      ? text('Ödeme adımında hesaplanır', 'Calculated at checkout')
      : (shipping === 0 ? text('Ücretsiz', 'Free') : money(shipping));
    const line = (label, value) => {const row = element('div'); row.append(element('dt', '', label), element('dd', '', value)); footerLines.append(row);};
    footerLines.replaceChildren();
    const breakdown = cartDiscountBreakdown();
    line(text('Ara toplam', 'Subtotal') + ' · ' + cartData.item_count + text(' ürün', cartData.item_count === 1 ? ' item' : ' items'), money(breakdown.subtotal));
    if (breakdown.discounts.length === 1) {
      const discount = breakdown.discounts[0];
      line(discount.title, '− ' + money(discount.amount));
    } else if (breakdown.discounts.length > 1) {
      // One summary row regardless of the number of promotions. The named
      // deductions expand above the footer without taking space from products.
      const row = element('div'), label = element('dt');
      const details = element('details', 'ghs-cart__discount-breakdown');
      details.append(element('summary', '', text('İndirimler', 'Discounts') + ' (' + breakdown.discounts.length + ')'));
      const list = element('dl', 'ghs-cart__discount-list');
      for (const discount of breakdown.discounts) {
        const entry = element('div');
        entry.append(element('dt', '', discount.title), element('dd', '', '− ' + money(discount.amount)));
        list.append(entry);
      }
      details.append(list); label.append(details);
      row.append(label, element('dd', '', '− ' + money(breakdown.discounts.reduce((sum, discount) => sum + discount.amount, 0))));
      footerLines.append(row);
    }
    if (cartData.requires_shipping) line(text('Kargo', 'Delivery'), shippingLabel);
    const values=element('dl','ghs-cart__totals-values');
    const add=(label,value)=>{const row=element('div');row.append(element('dt','',label),element('dd','',value));values.append(row);};
    add(text('Ara toplam','Subtotal'),money(breakdown.subtotal));
    for (const discount of breakdown.discounts) add(discount.title, '− ' + money(discount.amount));
    add(text('Kargo','Delivery'),cartData.requires_shipping?shippingLabel:money(0));
    const total=element('div','ghs-cart__total');total.append(element('span','',text('Toplam','Order total')),element('span','',money(orderTotal - breakdown.extra)));
    summary.append(values, total);
    const totalValue = element('span', 'ghs-cart__footer-amount');
    totalValue.append(element('span', '', money(orderTotal - breakdown.extra)));
    footerTotal.replaceChildren(element('span', '', text('Toplam', 'Total')), totalValue);
    if (shipping === null) {
      const note = element('p', 'ghs-cart__shipping-hint', text('Kargo ve varsa kargo indirimi ödeme adımında hesaplanır.', 'Delivery and any delivery discount are calculated at checkout.'));
      summary.append(note);
    }
  }

  // Preserve Giesto saved items and its shared size-picker integration.
  let wishlistRequest = 0;
  async function renderWishlist(saved) {
    const version = ++wishlistRequest;
    itemsPanel.replaceChildren();
    if (host.dataset.customer !== 'true') itemsPanel.append(wishlistPromo());
    if (!saved.length) {itemsPanel.append(wishlistEmpty());return;}

    // The rail is a teaser of the most recent saves, as its heading says; the
    // whole list lives on the wishlist page behind the call to action.
    const recent = saved.slice(0, 8);
    const products = await Promise.all(recent.map(async item => {
      const handle = wishlistHandle(item);
      if (!handle) return {item, variants: []};
      try {
        const product = await cartProduct(handle);
        return {item, product, variants: Array.isArray(product.variants) ? product.variants : []};
      } catch { return {item, variants: []}; }
    }));
    if (version !== wishlistRequest || activeTab !== 'saved') return;

    itemsPanel.append(wishlistCarousel(products), wishlistCta());
  }
  /* Saved items do not all carry a handle — one stored before the field existed,
     or added by a control that never set it, has only its URL — and without a
     handle there is no product to fetch, which is what left the size drawer
     with nothing to list. */
  function wishlistHandle(item) {
    if (item.handle) return item.handle;
    const path = String(item.url || '');
    return path.split('/products/')[1]?.split(/[?#]/)[0] || '';
  }
  function wishlistPromo() {
    const wrap = element('div','ghs-cart__member');
    wrap.append(element('p','',text('Favorilerinizi bu cihazda görebilir ve alışverişe devam edebilirsiniz.','View your saved items on this device and continue shopping.')));
    const action = element('a','',text('Giriş yap','Sign in'));
    action.href = host.dataset.loginUrl || local('/account/login');
    wrap.append(action);return wrap;
  }
  function wishlistEmpty() {
    const empty = element('div','ghs-cart__empty');
    const media = element('div','ghs-cart__empty-media');media.setAttribute('aria-hidden','true');
    empty.append(media,element('h3','',text('Favorileriniz boş','Your wishlist is empty')));
    const button = element('button','',text('Alışverişe devam et','Continue shopping'));
    button.addEventListener('click',()=>close(cart));empty.append(button);
    return empty;
  }
  function wishlistCta() {
    const wrap = element('div','ghs-wishlist__cta');
    const link = element('a','',text('Favorilere devam et','Continue to wishlist'));
    link.href = local('/pages/favori');
    wrap.append(link);return wrap;
  }
  function wishlistCarousel(entries) {
    const section = element('section','ghs-wishlist');
    const head = element('div','ghs-wishlist__head');
    head.append(element('h3','',text('Favorilere son eklenenler','Recently added to wishlist')));
    const rail = element('ul','ghs-wishlist__rail');rail.setAttribute('role','list');
    // The reference only draws the arrows once the rail has more than it can
    // show, and hides them below its tablet breakpoint.
    const nav = element('div','ghs-wishlist__nav');
    const controls = [];
    for (const direction of [-1, 1]) {
      const button = element('button');button.type='button';
      button.setAttribute('aria-label',text(direction === 1 ? 'Sonraki' : 'Önceki', direction === 1 ? 'Next' : 'Previous'));
      button.append(icon(direction === 1 ? 'navigate-arrow-right' : 'navigate-arrow-left'));
      button.addEventListener('click',()=>{
        const step = rail.querySelector('li')?.getBoundingClientRect().width || rail.clientWidth;
        rail.scrollBy({left: step * direction, behavior: 'smooth'});
      });
      nav.append(button);controls.push(button);
    }
    const syncNav = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      nav.hidden = max <= 1;
      controls[0].disabled = rail.scrollLeft <= 1;
      controls[1].disabled = rail.scrollLeft >= max - 1;
    };
    rail.addEventListener('scroll', syncNav, {passive: true});
    head.append(nav);section.append(head, rail);

    for (const entry of entries) rail.append(wishlistCard(entry));
    requestAnimationFrame(syncNav);
    return section;
  }
  function wishlistCard({item, product, variants}) {
    const slide = element('li');
    const card = element('article','ghs-wishlist__card');
    card.dataset.gsSizeSource = '';
    const handle = wishlistHandle(item);
    const href = productLink(item.url || '/products/' + handle);
    const media = element('a','ghs-wishlist__card-media');media.href = href;media.setAttribute('aria-hidden','true');media.tabIndex = -1;
    const imageUrl = item.image || product?.featured_image || product?.images?.[0];
    if (imageUrl) {const img=element('img');img.src=cartImage(imageUrl,384);img.alt='';img.loading='lazy';img.decoding='async';media.append(img);prepareCartImage(img,media);}
    const info = element('a','ghs-wishlist__card-info');info.href = href;
    info.append(element('span','',productTitle(item.title || product?.title || '')));
    info.append(element('span','ghs-wishlist__card-price',item.price || (product ? money(product.price) : '')));

    // The + opens the shared size picker, the same control the recently-viewed
    // rail uses; the filled heart takes the product back off the wishlist.
    const actions = element('div','ghs-wishlist__card-actions');
    const add = element('button','ghs-wishlist__card-add');add.type='button';
    add.setAttribute('aria-label',text('Beden seç: ','Choose size: ') + productTitle(item.title || ''));
    add.append(icon('navigate-plus'));
    add.dataset.productId = String(product?.id || item.id || '');
    add.dataset.productUrl = href;
    add.dataset.productTitle = productTitle(item.title || product?.title || '');
    add.dataset.productHandle = product?.handle || handle || '';
    add.dataset.gacReminders = '';
    const sizePosition = (product?.options || []).findIndex(option => /size|beden/i.test(option.name || option));
    add.dataset.sizePosition = String(sizePosition < 0 ? 0 : sizePosition);
    add.dataset.gacSizeTrigger = '';
    const variantsData = element('script');variantsData.type='application/json';variantsData.dataset.gacVariants='';
    variantsData.textContent = JSON.stringify(variants.map(variant => ({id:variant.id, available:variant.available, options:variant.options})));
    const favourite = element('button','ghs-wishlist__card-fav');favourite.type='button';
    favourite.setAttribute('aria-label',text('Favorilerden çıkar','Remove from wishlist'));
    favourite.setAttribute('aria-pressed','true');
    favourite.append(icon('header-wishlist-active'));
    favourite.addEventListener('click',()=>{window.GiestoWishlist?.remove(String(item.id));renderCart();});
    actions.append(add, element('span','ghs-wishlist__card-divider'), favourite);
    card.append(media, info, variantsData, actions);slide.append(card);return slide;
  }
  const cartProducts = new Map();
  function cartProduct(handle) {
    const cached = cartProducts.get(handle);
    if (cached && Date.now() - cached.at < 60000) return cached.promise;
    const promise = fetch(local('/products/' + encodeURIComponent(handle) + '.js')).then(response => {
      if (!response.ok) throw new Error('Product unavailable');
      return response.json();
    }).catch(error => {cartProducts.delete(handle);throw error;});
    if (cartProducts.size >= 32) cartProducts.delete(cartProducts.keys().next().value);
    cartProducts.set(handle, {at:Date.now(), promise});return promise;
  }
  const recommendationCache = new Map();
  let recentSignature = '', cancelRecentWait;
  async function renderRecent() {
    cancelRecentWait?.();
    const version = ++recentRequest;
    if (!recent || !recentRail || activeTab !== 'cart') {
      if (recent) recent.hidden = true;
      return;
    }
    const history = readRecent().slice(0,4);
    const productId = cartData?.items?.[0]?.product_id;
    // Both groups count as exposed here: this is where the rail would show.
    if (productId) window.GiestoDeney?.seen('sepet-oneri');
    if (productId && !cartRecommendations()) {recent.hidden = true;recentRail.replaceChildren();recentSignature='';return;}
    const signature = productId ? String(productId) : history.map(item=>item.handle).join(',');
    if (!signature) {recent.hidden = true;recentRail.replaceChildren();recentSignature='';return;}
    if (signature === recentSignature && recentRail.childElementCount) {recent.hidden=false;return;}
    recent.hidden=false;
    // giesto-funnel.js reports clicks here as sepet_onerileri or son_bakilanlar.
    recent.dataset.ghsRecentKind = productId ? 'oneri' : 'son';
    recent.querySelector('h3').textContent = productId ? text('Şunları da beğenebilirsiniz','You may also like') : text('Son görüntülenenler','Recently viewed');
    try {
      await new Promise(resolve => {
        const finish=()=>{observer.disconnect();cart.removeEventListener('close',finish);cancelRecentWait=null;resolve();};
        const observer = new IntersectionObserver(entries => {
          if(entries.some(entry=>entry.isIntersecting))finish();
        }, {root:cart.querySelector('.ghs-cart__scroll'), rootMargin:'160px'});
        cancelRecentWait=finish;observer.observe(recent);
        cart.addEventListener('close',finish,{once:true});
      });
      if(version!==recentRequest || activeTab!=='cart' || !cart.open)return;
      let products;
      if(productId){
        if(!recommendationCache.has(productId)){
          if(recommendationCache.size>=8)recommendationCache.delete(recommendationCache.keys().next().value);
          recommendationCache.set(productId,fetch(local('/recommendations/products.json')+'?product_id='+encodeURIComponent(productId)+'&limit=4&intent=related').then(response=>{
            if(!response.ok)throw new Error('Recommendations unavailable');return response.json();
          }).then(data=>data.products||[]).catch(error=>{recommendationCache.delete(productId);throw error;}));
        }
        products=await recommendationCache.get(productId);
      }else products=(await Promise.all(history.map(item=>cartProduct(item.handle).catch(()=>null)))).filter(Boolean);
      recentSignature=signature;
      if (version !== recentRequest || activeTab !== 'cart') return;
      recentRail.replaceChildren();
      for (const product of products) {
        const card = element('article','ghs-recent__card');
        card.dataset.gsSizeSource = '';
        card.setAttribute('role','listitem');
        const link = element('a');link.href = productLink(product.url || '/products/' + product.handle);link.setAttribute('aria-label',productTitle(product.title || ''));
        const imageUrl = product.featured_image || product.images?.[0];
        if (imageUrl) {const img=element('img');img.src=cartImage(imageUrl,384);img.alt=productTitle(product.title || '');img.loading='lazy';img.decoding='async';img.width=192;img.height=288;link.append(img);prepareCartImage(img,link);}
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const variantsData = element('script');variantsData.type='application/json';variantsData.dataset.gacVariants='';variantsData.textContent=JSON.stringify(variants.map(item=>({id:item.id,available:item.available,options:item.options})));
        const add = element('button','ghs-recent__add','+');add.type='button';add.setAttribute('aria-label',text('Beden seç: ','Choose size: ') + (productTitle(product.title || '')));
        add.dataset.productId=String(product.id || '');add.dataset.productHandle=product.handle || '';add.dataset.productUrl=link.href;add.dataset.productTitle=productTitle(product.title || '');
        // Sold-out sizes get the restock bell, as on collection cards.
        add.dataset.gacReminders='';
        const sizePosition = (product.options || []).findIndex(option => /size|beden/i.test(option.name || option));
        add.dataset.sizePosition=String(sizePosition < 0 ? 0 : sizePosition);
        add.dataset.gacSizeTrigger='';
        const caption=element('a','ghs-recent__caption');caption.href=link.href;caption.append(element('span','',productTitle(product.title)),element('span','',money(product.price)));
        card.append(link,caption,variantsData,add);recentRail.append(card);
      }
      recent.hidden = !products.length;
    } catch {if(version===recentRequest){recent.hidden=true;recentRail.replaceChildren();}}
  }
  async function changeItem(key, quantity) {
    if (cartBusy || cartMutation) return;
    cartMutation = true; ++cartRequest; cartRead=null; setCartBusy(true);
    try {
      const response = await fetch(local('/cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message);
      cartData = data; cartStatus.textContent = ''; discountStatus.textContent = '';
      document.dispatchEvent(new CustomEvent('giesto:cart:change',{detail:data}));
    } catch (error) {
      funnel('cart_error', {code: 'CART_CHANGE_FAILED', message: error?.message});
      cartStatus.textContent = text('Sepet güncellenemedi. Tekrar deneyin.', 'Could not update your cart. Please try again.');
      console.error('giesto-header-surfaces:', error);
    }
    cartMutation = false; setCartBusy(false);
    renderCart(true);
  }
  for (const tab of cart.querySelectorAll('[data-ghs-tab]')) {
    tab.addEventListener('click',()=>{activeTab=tab.dataset.ghsTab;renderCart();});
    tab.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();activeTab = activeTab === 'cart' ? 'saved' : 'cart';renderCart();cart.querySelector('[aria-selected=true]').focus();});
  }
  document.addEventListener('giesto:wishlist:change',()=>{if(cart.open)renderCart();});
  document.addEventListener('giesto:cart:change',event=>{
    const data=event.detail;if(data?.item_count !== undefined)syncCartCount(data.item_count);
    if(cartMutation)return;
    ++cartRequest;cartRead=null;
    cartData=Array.isArray(data?.items)?data:null;
    if(cart.open){if(cartData){setCartBusy(false);renderCart();}else loadCart();}
  });
  document.addEventListener('giesto:cart:open',event=>{activeTab=event.detail?.tab==='saved'?'saved':'cart';show(cart,event.detail?.trigger || headerControl('[data-testid=header-cart]'));loadCart();});
  document.addEventListener('shopify:cart:lines-update',event=>{
    if(!(event.promise instanceof Promise))return;
    const fromCartSize=Boolean(document.querySelector('#GiestoStoreSizePicker[data-cart][open]'));
    event.promise.then(result=>{
      if(result?.detail?.didError)return;
      if(event.action==='add'&&fromCartSize)close(cart);
      loadCart();
    }).catch(()=>{});
  });
  document.addEventListener('cart:update',()=>{
    if(cartMutation)return;
    cartData=null;cartRead=null;const version=++cartRequest;
    if(cart.open){loadCart();return;}
    readCart().then(data=>{if(version!==cartRequest || cartMutation)return;cartData=data;syncCartCount(data.item_count || 0);}).catch(()=>{});
  });
  rememberCurrentProduct();
  syncAccountState();
  /* /cart is this cart opened in place, so returning from checkout shows the
     cart the header opens (YUN-78). Closing it goes back to the shop page the
     shopper came from, or home when they came from checkout. */
  if (cartPage) {
    cart.addEventListener('close', () => {
      let target = local('/');
      try {
        const from = new URL(document.referrer);
        if (from.origin === location.origin && !/\/(cart|checkouts?)(\/|$)/.test(from.pathname)) target = from.href;
      } catch { /* No referrer: go home. */ }
      location.assign(target);
    });
    window.addEventListener('pageshow', event => {if (!event.persisted) return;activeTab = 'cart';if (!cart.open) show(cart, null);loadCart();});
    activeTab = 'cart'; show(cart, null); loadCart();
  } else {
    const initialCartVersion=cartRequest;
    readCart().then(data=>{if(initialCartVersion!==cartRequest || cartMutation)return;cartData=data;syncCartCount(data.item_count || 0);}).catch(()=>{});
  }
  window.addEventListener('pagehide',()=>{search.close();if(!cartPage)cart.close();account?.close();});
})();
